import styled from 'styled-components';

export const CellSpan = styled.span`
  color: #4948ac;

  &:hover {
    cursor: pointer;

    color: #2dcaff;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%
  padding: 20px;
  background-color: #f4f4f4;
`;

export const PageTitle = styled.h1`
  font-size: 3rem;
  color: #1a1a32;
  font-weight: 600;
  margin-bottom: 20px;
`;

export const ScreenHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  padding: 20px 40px;
  max-height: auto;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

export const RightHeader = styled.div`
  width: 60%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  max-height: auto;
`;

export const ActionCommomdropdown = styled.div`
  select : {
    background-color: white !important;
    color: black !important;
  }
`;

export const CustomDropdownWrapper = styled.div`
  position: relative;
  display: inline-block;
  width: 160px; // Set width for dropdown
`;

export const DropdownButton = styled.button<{ disabled?: boolean }>`
  background-color: ${({ disabled }) => (disabled ? 'rgb(201, 203, 211)' : '#4948ac')};
  color: white;
  padding: 8px 20px;
  border-radius: 4px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  width: 90%;
  text-align: left;
  display: flex;
  justify-content: space-between;
  border: 0.5px solid rgb(73, 72, 172);
  align-items: center; // Align the text and arrow icon
  margin: 0.5em;
  font-weight: 500;
  max-height: 36px;
  font-size: 1.6rem;
`;

export const ArrowIcon = styled.span<{ open: boolean }>`
  transform: ${({ open }) => (open ? 'rotate(180deg)' : 'rotate(0deg)')}; // Rotate the arrow when open
  transition: transform 0.3s ease;
`;

export const DropdownList = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1;
  max-height: 200px;
  overflow-y: auto;
`;

export const DropdownItem = styled.div`
  padding: 10px;
  cursor: pointer;
  :hover {
    background-color: #f0f0f0;
  }
`;
